const MFE_URL_PLACEHOLDER = '__MFE_URL_PLACEHOLDER__'

const MFE_REMOTES = {
  contrastBase: 'contrastBase/mf-manifest.json',
  orgSettings: 'orgSettings/mf-manifest.json',
  adrContrastGraph: 'adrContrastGraph/mf-manifest.json',
  platformRepositories: 'platformRepositories/mf-manifest.json',
  platformAuthz: 'platformAuthz/mf-manifest.json',
  superadmin: 'superadmin/mf-manifest.json',
  platformReports: 'platformReports/mf-manifest.json',
  attackEvents: 'attackEvents/mf-manifest.json',
  platformUserSettings: 'platformUserSettings/mf-manifest.json',
  platformAppConfig: 'platformAppConfig/mf-manifest.json',
  agentsDashboardMfe: 'agentsDashboardMfe/mf-manifest.json'
}

module.exports = { MFE_URL_PLACEHOLDER, MFE_REMOTES }
